var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-input',{attrs:{"label":_vm.label,"value":_vm.value,"imask":{
        mask: 'xxxxxxxxxxxxxxxxxxxx',
        prepare: function (str) {
            return str.toLowerCase()
        },
        definitions: {
            'x': /[a-z0-9]/
        }
    },"disabled":_vm.disabled,"suffix":("." + _vm.domain),"extra-info":"What is this?"},on:{"extra-info-click":_vm.showInfo,"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }